// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HWQ2X","top":"styles_top__2M2q-","left":"styles_left__1Q3uU","description":"styles_description__1pDMG"};